import { render } from "./gallery-section.vue?vue&type=template&id=bd8e4720"
import script from "./gallery-section.vue?vue&type=script&lang=js"
export * from "./gallery-section.vue?vue&type=script&lang=js"

import "./gallery-section.vue?vue&type=style&index=0&id=bd8e4720&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__